import Moment from 'moment'

const EFECTIVO = 1
const TARJETA_CREDITO = 2

export function formatearFecha(fecha, formato = 'FH', sufijo = '') {
  if (!fecha || fecha === '0001-01-01T00:00:00') {
    return ''
  }
  let newFecha
  switch (formato) {
    case 'F':
      formato = 'DD/MM/YYYY'
      break
    case 'H':
      formato = 'HH:mm'
      break
    case 'FH':
      formato = 'DD/MM/YYYY - HH:mm'
      break
    case 'H24':
      formato = 'HH:mm'
      break
    case 'EN':
      formato = 'YYYY/MM/DD'
      break
    case 'ISO':
      if (!fecha) {
        return ''
      }

      if (fecha instanceof Date) {
        return fecha.toISOString()
      }

      newFecha = new Date(fecha)
      if (isNaN(newFecha)) {
        return ''
      }

      return newFecha.toISOString()
    default:
      formato = 'DD/MM/YYYY - HH:mm'
  }
  return fecha ? Moment(fecha).format(formato) + sufijo : ''
}

export function formatearMonto(monto, simbolo = '') {
  simbolo = simbolo === '' ? '' : formatearMoneda(simbolo)
  return (
    <>
      {simbolo} {monto}
    </>
  )
}

export function formatearMoneda(simbolo) {
  switch (simbolo.trim()) {
    case '$':
      simbolo = 'usd'
      break
    case '?':
      simbolo = 'eur'
      break
    default:
      simbolo = 'usd'
  }
  return <i className={`fa fa-${simbolo}`} aria-hidden="true" />
}

export function formatearMedioPago(idMedioPago) {
  let iconoMedioPago

  switch (idMedioPago) {
    case EFECTIVO:
      iconoMedioPago = 'fa-money'
      break
    case TARJETA_CREDITO:
      iconoMedioPago = 'fa-cc-visa'
      break
    default:
      iconoMedioPago = 'fa-money'
      break
  }
  return <i className={`fa ${iconoMedioPago} fa-fw`} aria-hidden="true" />
}

export function formatearTexto(texto) {
  return texto === null ? '' : texto
}

export function formatearDireccion(calle, altura, piso, cp) {
  let direccion = `${formatearTexto(calle)} ${formatearTexto(altura)}, ${formatearTexto(cp)}`
  if (piso !== null) {
    direccion += `, ${piso}`
  }
  return direccion
}

export function fechaSQL(fecha, separador) {
  const [dia, mes, anio] = fecha.split(separador)
  return anio + mes + dia
}
